import { Controller } from "@hotwired/stimulus"

const DISMISS_KEY = "pwa-reinstall-dismissed"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    if (this.shouldShow()) {
      this.open()
    } else {
      this.close()
    }
  }

  shouldShow() {
    if (localStorage.getItem(DISMISS_KEY) === "true") return false
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      navigator.standalone === true
    const fromLegacy =
      document.referrer.includes("testly.pl") &&
      !document.referrer.includes("app.testly.pl")
    return isStandalone && fromLegacy
  }

  open() {
    this.bannerTarget.classList.remove("hidden")
  }

  close() {
    this.bannerTarget.classList.add("hidden")
  }

  dismiss(event) {
    event.preventDefault()
    localStorage.setItem(DISMISS_KEY, "true")
    this.close()
  }
}
